import { Alert, Card, Form } from 'antd';
import { useEffect, useState } from 'react';

import {
    NurseProfileDto,
    ShiftListItemDto,
    WorkQualificationResultDto,
} from '@clh/api-client';
import { unwrapError, useApiClient } from '@clh/ui';

import { useSelection } from '../../../hooks/use-selection';
import { useToast } from '../../../hooks/use-toast';
import { ValidationResultsTable } from '../../../profiles/match-qualification-check-form';
import ProfileAutoComplete from '../../../profiles/profile-autocomplete';

export const AuthorizationChecker = () => {
    const api = useApiClient();
    const { selection } = useSelection<ShiftListItemDto>();
    const [profile, setProfile] = useState<NurseProfileDto | undefined>(
        undefined
    );
    const [isChecking, setIsChecking] = useState<boolean>(false);
    const [result, setResult] = useState<
        WorkQualificationResultDto | undefined
    >(undefined);
    const { notification } = useToast();

    const checkAuthorization = async () => {
        if (!profile) {
            return;
        }

        setIsChecking(true);
        setResult(undefined);

        try {
            const res =
                await api?.workQualificationControllerGetShiftQualifications({
                    shiftCandidatesDto: {
                        candidates: [
                            {
                                ...selection,
                                state: selection.facility.address.state,
                            },
                        ],
                    },
                    nurseProfileId: profile.id,
                });

            setResult(res);
        } catch (error: any) {
            notification.error({ message: unwrapError(error), duration: 3 });
        } finally {
            setIsChecking(false);
        }
    };

    useEffect(() => {
        void checkAuthorization();
    }, [profile?.id]);

    return (
        <Card size="small" title="Match Qualification Checker">
            <Form.Item label="Nurse">
                <ProfileAutoComplete
                    autoFocus={false}
                    placeholder="Enter name"
                    allowClear={true}
                    onClear={() => {
                        setProfile(undefined);
                        setResult(undefined);
                    }}
                    disabled={isChecking}
                    onSelect={(nurse) => {
                        setProfile(nurse);
                    }}
                />
            </Form.Item>
            {result && profile && (
                <>
                    <b>Results:</b>
                    <Alert
                        type={result.qualified > 0 ? 'success' : 'error'}
                        message={
                            result.qualified > 0
                                ? 'Qualified for this shift'
                                : 'Not qualified for this shift'
                        }
                        showIcon
                    />
                    {result.results[0].validationResults && (
                        <ValidationResultsTable
                            validationResults={
                                result.results[0].validationResults
                            }
                        />
                    )}
                </>
            )}
        </Card>
    );
};
